import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ThemeSwitcher from "./ThemeSwitcher";
import {
  SquaresFour, ListDashes, Briefcase, Trophy, ChatsCircle, SlidersHorizontal,
  SignOut, Pulse, House,
} from "@phosphor-icons/react";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: SquaresFour, id: "nav-dashboard" },
  { to: "/hotlist", label: "Hot List", icon: ListDashes, id: "nav-hotlist" },
  { to: "/portfolio", label: "Portfolio", icon: Briefcase, id: "nav-portfolio" },
  { to: "/performance", label: "Performance", icon: Trophy, id: "nav-performance" },
  { to: "/messages", label: "Feed", icon: ChatsCircle, id: "nav-messages" },
  { to: "/integrations", label: "Integrations", icon: SlidersHorizontal, id: "nav-integrations" },
];

export default function Shell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-40 px-4 pt-4">
        <div className="max-w-7xl mx-auto glass-strong rounded-full px-3 py-2 flex items-center gap-2">
          <button onClick={() => navigate("/dashboard")} className="flex items-center gap-2 pl-2 pr-3 shrink-0" data-testid="shell-logo">
            <div className="w-8 h-8 rounded-full brand-gradient flex items-center justify-center shadow-lg">
              <Pulse size={17} weight="bold" className="text-white" />
            </div>
            <span className="font-display font-extrabold tracking-tight hidden sm:block">Signal<span className="brand-text">Desk</span></span>
          </button>

          <nav className="flex items-center gap-1 flex-1 overflow-x-auto no-scrollbar">
            {NAV.map((n) => {
              const Icon = n.icon;
              return (
                <NavLink
                  key={n.to}
                  to={n.to}
                  data-testid={n.id}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                      isActive ? "brand-gradient text-white shadow-md" : "text-muted-foreground hover:text-foreground hover:bg-foreground/5"
                    }`
                  }
                >
                  <Icon size={16} weight="bold" />
                  <span className="hidden md:block">{n.label}</span>
                </NavLink>
              );
            })}
          </nav>

          <ThemeSwitcher />
          <button onClick={() => navigate("/")} title="Public site" data-testid="go-public"
            className="w-9 h-9 rounded-full flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition-colors duration-200">
            <House size={16} weight="bold" />
          </button>
          <button data-testid="logout-btn" onClick={logout} title={user?.email}
            className="w-9 h-9 rounded-full flex items-center justify-center text-muted-foreground hover:text-bear hover:bg-bear/10 transition-colors duration-200">
            <SignOut size={16} weight="bold" />
          </button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">{children}</main>
    </div>
  );
}
